import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { PrescriptionTypes } from '@lib/prescriptions/data-access';

@Component({
  selector: 'prescriptions-icon',
  standalone: true,
  imports: [TranslatePipe, MatIcon, NgClass, MatTooltip],
  templateUrl: './prescription-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionIconComponent {
  prescriptionType = input.required<PrescriptionTypes>();
  showLabel = input<boolean>(true);

  protected readonly type = PrescriptionTypes;

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon('pill', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_pill.svg'));
    iconRegistry.addSvgIcon('diagnostics', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_diagnostics.svg'));
    iconRegistry.addSvgIcon('laboratory', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_laboratory.svg'));
    iconRegistry.addSvgIcon('doctor', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/ic_doctor.svg'));
  }

  protected getIconName(type: PrescriptionTypes): string {
    switch (type) {
      case PrescriptionTypes.Drugs:
        return 'pill';
      case PrescriptionTypes.InstrumentalDiagnostic:
        return 'diagnostics';
      case PrescriptionTypes.LaboratoryService:
        return 'laboratory';
      default:
        return 'doctor';
    }
  }
}